import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-24 bg-charcoal relative border-y border-gold/10" data-id="element-283">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl text-center" data-id="element-284">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-285">
          <div className="flex justify-center mb-6" data-id="element-286">
            <Shield className="w-12 h-12 text-gold" data-id="element-287" />
          </div>

          <h2 className="text-2xl md:text-3xl font-serif font-bold text-cream" data-id="element-288">
            Nuestra promesa es simple
          </h2>

          <p className="text-lg md:text-xl text-cream/80 font-light leading-relaxed" data-id="element-289">
            Si el día de tu evento nuestro servicio no cumple con la calidad, la
            elegancia y el cariño que prometemos — trabajamos contigo para
            resolverlo. Sin excusas.
          </p>

          <p className="text-lg md:text-xl text-cream/80 font-light leading-relaxed" data-id="element-290">
            Llegamos a tiempo. Nos quedamos hasta el final. Tratamos a tu
            familia con el mismo respeto con que trataríamos a la nuestra.
          </p>

          <div className="pt-8" data-id="element-291">
            <p className="font-script text-4xl md:text-5xl text-gold" data-id="element-292">
              Porque para nosotros, tu evento no es un trabajo. Es un honor.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}